import moment from 'moment'

export default {
	// Inhalt des Modals
	model: {
		id: 0,
		name: '',
		from: moment(Date.now()).format('YYYY-MM-DD'),
		until: moment(moment(Date.now()).add(25, 'years')).format('YYYY-MM-DD'),
		deceased: '',
		grave_id: 0,
		price: 0,
		status: 0,
		area_id: 0,
		area_name: '',
		description: '',
		real_price: 0,
		category_price: 0,
		category_name: '',
		category_short_name: '',
		area_price: 0,
		type_name: '',
		type_short_name: '',
		type_id: 0,

		forced: true

	},

	relations: [
		'customers',
		'deceaseds',
		'areas',
		'grave_types'
	],

	name: 'graves',

	customers: [],
	deceaseds: [],

	validate () {
		var parts = this.model.name.split(':')

		this.model.grave_id = parts[0]
		this.model.grave_id = parseInt(this.model.grave_id)
		this.model.from = moment(this.model.from, 'YYYY-MM-DD').toISOString()
		this.model.until = moment(this.model.until, 'YYYY-MM-DD').toISOString()

		this.model.price = parseInt(this.model.price)
		this.model.area_id = parseInt(this.model.area_id)
		this.model.status = parseInt(this.model.status)

		this.model.forced = true

		this.model.type_id = parseInt(this.model.type_id)

		return true
	},

	validateModel () {
		this.model.from = null
		this.model.until = null

		this.model.price = parseInt(this.model.price)
		this.model.area_id = parseInt(this.model.area_id)
		this.model.status = parseInt(this.model.status)

		const TypeOK = typeof this.model.type_id === "number" && this.model.type_id > 0 && Math.floor(this.model.type_id) === this.model.type_id
		const NameOK = typeof this.model.name === "string" && this.model.name.trim() !== ""
		const AreaOK = typeof this.model.area_id === "number" && this.model.area_id > 0 && Math.floor(this.model.area_id) === this.model.area_id

		return TypeOK && NameOK && AreaOK
	},

	copy (aModel) {
		if (typeof aModel === 'undefined') {
			return
		}

		this.model.id = aModel.id || 0
		this.model.name = aModel.name
		this.model.from = aModel.from
		this.model.until = aModel.until
		this.model.deceased = aModel.deceased || ''
		this.model.grave_id = aModel.grave_id || 0
		this.model.price = aModel.price || 0
		this.model.status = aModel.status || 0
		this.model.area_id = aModel.area_id || 0
		this.model.area_name = aModel.area_name || ''
		this.model.description = aModel.description || ''
		this.model.area_price = aModel.area_price || 0
		this.model.category_price = aModel.category_price || 0
		this.model.category_name = aModel.category_name || ''
		this.model.category_short_name = aModel.category_short_name || ''
		this.model.type_name = aModel.type_name || ''
		this.model.type_short_name = aModel.type_short_name || ''
		this.model.type_id = parseInt(aModel.type_id) || 0

		this.model.forced = true
	},

	// Die Spalten für die Tabelle
	cols: [
		{name: 'Name', json: 'name', type: 'text'},
		{name: 'Von', json: 'from', type: 'date', 'colCSS': 'hidden-xs'},
		{name: 'Bis', json: 'until', type: 'date', 'colCSS': 'hidden-xs'},
		{name: 'Verstorbener', json: 'deceased', type: 'text'},
		{name: 'Fläche', json: 'area', type: 'text'}
	],

	clear () {
		this.model.id = 0
		this.model.name = ''
		this.model.from = moment(Date.now()).format('YYYY-MM-DD')
		this.model.until = moment(moment(Date.now()).add(25, 'years')).format('YYYY-MM-DD')
		this.model.deceased = ''
		this.model.status = 0
		this.model.price = 0
		this.model.area_id = 0
		this.model.area_name = ''
		this.model.description = ''
		this.model.area_price = 0
		this.model.category_price = 0
		this.model.category_name = ''
		this.model.category_short_name = ''
		this.model.type_name = ''
		this.model.type_short_name = ''
		this.model.type_id = 0

		this.customers = []
		this.deceaseds = []

		this.model.forced = true
	},

	clearModel () {
		this.model.name = ''
		this.model.from = null
		this.model.until = null
		this.model.deceased = ''
		this.model.status = 0
		this.model.price = 0
		this.model.area_id = 0
		this.model.area_name = ''
		this.model.description = ''
		this.model.area_price = 0
		this.model.category_price = 0
		this.model.category_name = ''
		this.model.category_short_name = ''
		this.model.type_name = ''
		this.model.type_short_name = ''
		this.model.type_id = 0

		this.customers = []
		this.deceaseds = []

		this.model.forced = true
	}
}



// WEBPACK FOOTER //
// ./src/models/graves.js